import restApiImage from "./api_rest_image.png";
import taskAiImages from "./hero-banner-sm.png";
import hero1 from "./hero1.jpg";
import hero2 from "./hero2.jpg";
import hero3 from "./hero3.jpg";
import phoneMokup from "./phoneMockup1.jpg";
import portfolioImage from "./portfolio.png";
import zenith from "./zenith.jpg";
import AiLandingImage from "./Thumbnail.png";

export const Images = {
  taskAiImages,
  portfolioImage,
  restApiImage,
  phoneMokup,
  zenith,
  hero1,
  hero2,
  hero3,
  AiLandingImage,
};
